const rootActionPath = 'core/EmailOptIn';

export const EMAIL_OPTIN_SECTION_VIEW = `${rootActionPath}/SECTION/VIEW`;
export const EMAIL_OPTIN_STATUS_CHANGED = `${rootActionPath}/STATUS/CHANGED`;
